import { SVGFC } from '@repo/toolkit/types'

const PharmacyIcon: SVGFC = ({ color, color2, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z"
        fill={color2}
      />
      <g clipPath="url(#clip0_10741_433668)">
        <path
          d="M10.2501 5.87402C10.1926 5.87402 10.1356 5.88536 10.0824 5.90738C10.0293 5.9294 9.98096 5.96166 9.94027 6.00234C9.89958 6.04303 9.86731 6.09133 9.84529 6.14449C9.82327 6.19765 9.81193 6.25463 9.81193 6.31217V9.81259H6.31317C6.19725 9.81259 6.08605 9.85854 6.00392 9.94035C5.92179 10.0222 5.87544 10.1332 5.875 10.2491V13.7495C5.875 13.8658 5.92116 13.9772 6.00334 14.0594C6.08551 14.1415 6.19696 14.1877 6.31317 14.1877H9.81193V17.6864C9.81193 17.8027 9.8581 17.9141 9.94027 17.9963C10.0224 18.0784 10.1339 18.1246 10.2501 18.1246H13.7505C13.8664 18.1242 13.9775 18.0778 14.0593 17.9957C14.1411 17.9136 14.187 17.8024 14.187 17.6864V14.1877H17.6874C17.8037 14.1877 17.9151 14.1415 17.9973 14.0594C18.0795 13.9772 18.1256 13.8658 18.1256 13.7495V10.2491C18.1252 10.1332 18.0788 10.0222 17.9967 9.94035C17.9146 9.85854 17.8034 9.81259 17.6874 9.81259H14.187V6.31217C14.187 6.19624 14.1411 6.08507 14.0593 6.00295C13.9775 5.92082 13.8664 5.87446 13.7505 5.87402H10.2501ZM10.6883 6.75036H13.3123V10.2491C13.3123 10.3653 13.3585 10.4768 13.4407 10.5589C13.5229 10.6411 13.6343 10.6873 13.7505 10.6873H17.2493V13.3113H13.7505C13.6343 13.3113 13.5229 13.3575 13.4407 13.4397C13.3585 13.5218 13.3123 13.6333 13.3123 13.7495V17.2499H10.6883V13.7495C10.6883 13.6333 10.6421 13.5218 10.5599 13.4397C10.4778 13.3575 10.3663 13.3113 10.2501 13.3113H6.74969V10.6873H10.2501C10.3663 10.6873 10.4778 10.6411 10.5599 10.5589C10.6421 10.4768 10.6883 10.3653 10.6883 10.2491V6.75036Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_10741_433668">
          <rect width="14" height="14" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PharmacyIcon
